import { Link } from "react-router-dom";

import { TermSearch } from "../components/TermSearch";
import { trpc } from "../trpc";

function Stat({ value, label }: { value: number | undefined; label: string }) {
  return (
    <div>
      <div className="font-serif text-3xl text-ink">
        {value === undefined ? "—" : value.toLocaleString()}
      </div>
      <div className="eyebrow mt-1">{label}</div>
    </div>
  );
}

const entries = [
  {
    to: "/glossary",
    title: "The glossary",
    body: "Every word, with its meaning shaded by the doha it lives in.",
  },
  {
    to: "/graph",
    title: "The graph",
    body: "Follow the threads — how words summon other words across the text.",
  },
  {
    to: "/dohas",
    title: "The dohas",
    body: "Walk the couplets mandal by mandal, each with its words gathered.",
  },
];

export function HomePage() {
  const stats = trpc.glossary.stats.useQuery();

  return (
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <section className="pt-16 sm:pt-24">
        <p className="eyebrow">A study of the Swarveda</p>
        <h1 className="mt-4 max-w-3xl font-serif text-5xl leading-[1.08] text-ink sm:text-6xl">
          Read a doha.{" "}
          <span className="italic text-terracotta">Understand</span> every word
          of it.
        </h1>
        <p className="mt-5 max-w-xl text-lg text-ink-soft">
          A quiet place to sit with the verse — look a word up, see how it turns
          from couplet to couplet, and mark the ones still waiting to be
          understood.
        </p>

        <div className="mt-9 max-w-2xl">
          <TermSearch />
        </div>
      </section>

      <section className="mt-16 grid grid-cols-2 gap-8 border-y border-line py-8 sm:grid-cols-4">
        <Stat value={stats.data?.terms} label="Words" />
        <Stat value={stats.data?.senses} label="Meanings" />
        <Stat value={stats.data?.dohas} label="Dohas" />
        <Stat value={stats.data?.links} label="Connections" />
      </section>

      <section className="mt-14 grid gap-5 sm:grid-cols-3">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group rounded-2xl border border-line bg-paper-raised p-6 transition-all hover:-translate-y-0.5 hover:border-line-strong hover:shadow-md"
          >
            <h3 className="font-serif text-2xl text-ink">{entry.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-ink-soft">
              {entry.body}
            </p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-terracotta">
              Enter
              <span className="transition-transform group-hover:translate-x-1">
                →
              </span>
            </span>
          </Link>
        ))}
      </section>
    </div>
  );
}
